import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.level.entry', value: 'entry' },
  { title: 'pages.onboarding.level.mid', value: 'mid' },
  { title: 'pages.onboarding.level.senior', value: 'senior' },
  { title: 'pages.onboarding.level.lead', value: 'lead' },
  { title: 'pages.onboarding.level.director', value: 'director' },
  { title: 'pages.onboarding.level.vp', value: 'vp' },
]

export default function LevelPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.level.title"
      layout="grid"
    />
  )
}
